import gql from 'graphql-tag';

export const updateServiceRequestMutation = gql`
  mutation updateServiceRequestMutation(
    $updateServiceRequest: UpdateServiceRequestDTO!
  ) {
    updateServiceRequest(serviceRequest: $updateServiceRequest) {
      serviceRequestId
      updatedAt
    }
  }
`;
